export default __webpack_public_path__ + "static/media/Flag_of_Kazakhstan.c7e0471b.svg";